export { PdfHighlighter } from "./components/PdfHighlighter";
export { Highlight } from "./components/Highlight";
export { PdfLoader } from "./components/PdfLoader";

export * from "./types";
